import React from "react";

export default function RenewalComponent() {
  return (
    <div className="about_area pt-45">
      <div className="container">
        <div className="row">
          

          {/* Text Content Section */}
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-6">
            <div className="section_title text_left mb-40 mt-3">
              
              <div className="section_main_title text-left">
                <h1>Prioritize Key Accounts with Refreshed
              
                <span> Renewal Intelligence.</span>
                </h1>
              </div>
              <div className="em_bar">
                <div className="em_bar_bg"></div>
              </div>
              
            </div>

            <div className="singel_about_left mb-30">
              <div className="singel_about_left_inner mb-3">
                <div className="singel-about-content text-left">
                  <p>
                  Gain a competitive edge with real-time renewal Intelligence for your key accounts. ProPlus Data tracks renewal timelines, empowering you to engage clients at the perfect moment, minimizing churn, and maximizing revenue. Discover expiring contracts and spark strategic conversations that boost retention and growth. </p>
                
                 
                </div>
              </div>

              
            </div>
          </div>
          {/* Image Section */}
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-6">
            <div className="about_thumb">
              <img src="/assets/images/renewal-and-subscription.gif" alt="renewal & Subscription insights" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
